import React from "react";
import Badge from "@mui/material/Badge";

const FloatTitleCard = ({ title = "", error = false, children = <></>, padding = 3, paddingTop = 4 }) => {
  return (
    <div
      className={`card mt-3 px-0 w-100 rounded-4${error ? " border-danger" : " border-bootstrap-gray-500"
        }`}
    >
      <Badge
        badgeContent={
          <h5
            className={`card-header-inline card-title fs-16 fw-medium${error
                ? " color-bootstrap-regular-danger"
                : " color-bootstrap-gray-600"
              } w-max ms-3 mb-0`}
          >
            {title}
          </h5>
        }
        color=""
      >
        <div className={`card-body position-relative p-lg-${padding} pt-lg-${paddingTop} px-12px`}>
          <div className="mt-lg-1 mt-2">{children}</div>
        </div>
      </Badge>
    </div>
  );
};

export default FloatTitleCard;
